import axios from "const/axios";

const base = "/marketing";

export function listMarketingConnections() {
  return axios.get(`${base}/connections`);
}

export function createMarketingConnection(body) {
  return axios.post(`${base}/connections`, body);
}

export function updateMarketingConnection(id, body) {
  return axios.put(`${base}/connections/${id}`, body);
}

export function deleteMarketingConnection(id) {
  return axios.delete(`${base}/connections/${id}`);
}

export function testMarketingConnection(id) {
  return axios.post(`${base}/connections/${id}/test`);
}

export function listMarketingPosts(params) {
  return axios.get(`${base}/posts`, { params });
}

export function syncCampaigns(connectionId) {
  return axios.post(`${base}/campaigns/sync`, null, { params: { connectionId } });
}

export function getCampaign(id) {
  return axios.get(`${base}/campaigns/${id}`);
}

export function listCampaigns(params) {
  return axios.get(`${base}/campaigns`, { params });
}

export function createPausedCampaign(body) {
  return axios.post(`${base}/campaigns`, body);
}

export function boostPost(body) {
  return axios.post(`${base}/campaigns/boost`, body);
}

export function pauseCampaign(id) {
  return axios.post(`${base}/campaigns/${id}/pause`);
}

export function activateCampaign(id) {
  return axios.post(`${base}/campaigns/${id}/activate`);
}

export function refreshCampaignInsights(id) {
  return axios.post(`${base}/campaigns/${id}/insights`);
}

export function uploadAdImage({ connectionId, file }) {
  const body = new FormData();
  body.append("connectionId", connectionId);
  body.append("file", file);
  return axios.post(`${base}/images`, body);
}

export function listCampaignLeads(id) {
  return axios.get(`${base}/campaigns/${id}/leads`);
}

export function createAd(body) {
  return axios.post(`${base}/campaigns/ad`, body);
}

export function searchInterests(params) {
  return axios.get(`${base}/interests`, { params });
}
